// import { useEffect, useState } from "react";
// // import logo from "../../../img/brand/logo.png";
// import logo2 from "../../../img/brand/sch_logo2.png";
// // import logo3 from "../../../img/brand/brand.png";
// import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
// import { Link, useLocation } from 'react-router-dom';
// import Utilities from "../../dependencies/custom/react-utilities";
// import ValuesStore from "../../store/values-store";
// function Sidenav({ cssClasses }) {
//   const valuesStore = ValuesStore();
//   const { pathname } = useLocation();
//   const [routes, setRoutes] = useState([]);

//   function sortByMinChild(arr, sortKey = 'order') {
//     return [...arr]
//       ?.sort(([, childrenA], [, childrenB]) => {
//         const minA = Math.min(...childrenA.map(c => c?.[sortKey]));
//         const minB = Math.min(...childrenB.map(c => c?.[sortKey]));
//         return minA - minB;
//       });
//   }

//   useEffect(() => {
//     const pages = valuesStore?.getValue("pages");
//     const groupedByParent = Utilities.groupBy(pages, 'parent');

//     // Step 2: Sort children within each parent group
//     Object.keys(groupedByParent).forEach(parent => {
//       groupedByParent[parent].sort((a, b) => a.order - b.order);
//     });

//     // Step 3: Sort parent groups by the minimum order of their children
//     const sortedParents = sortByMinChild(Object.entries(groupedByParent));
//     let arr = [];
//     for (let entry of sortedParents) {
//       const [key, value] = entry;
//       if (key === 'null') {
//         for (let v of value) {
//           arr.push([v?.custom_name, [v]])
//         }
//       } else {
//         arr.push([key, value]);
//       }
//     }
//     const sortedParents2 = sortByMinChild(arr);

//     setRoutes(sortedParents2);
//   }, []);

//   return (
//     <Sidebar
//       className={`${cssClasses}`}
//       breakPoint="md"
//       style={{
//         position: "fixed",
//         left: 0,
//         top: 0,
//         height: "100vh",
//         // zIndex: 1000,
//       }}

//     >

//       <div className="d-flex justify-content-center mt-3">
//         <img className="mb-2" src={logo2} alt="" width={80} />
//       </div>
//       <div className="d-flex justify-content-center mb-5 text-center">
//         <label className="h6 fw-boldx text-wrap" style={{ maxWidth: '70%' }}>
//           Hillside Nursery & Primary Schools Naalya
//         </label>
//       </div>

//       <Menu iconShape="circle">
//         {routes.map(([parentName, children]) => {

//           if (children.length == 1) {
//             return children.map(item => (
//               <MenuItem
//                 key={item.name}
//                 icon={item.icon ? <i className={item.icon} /> : null}
//                 active={pathname === item.route}
//                 component={<Link to={item.route} />}
//               >
//                 {item.custom_name}
//               </MenuItem>
//             ));
//           }

//           const parentIcon = children.find(c => c.parent_icon)?.parent_icon;
//           return (
//             <SubMenu
//               key={parentName}
//               label={parentName}
//               icon={parentIcon ? <i className={parentIcon} /> : null}
//             >
//               {children.map(item => (
//                 <MenuItem
//                   key={item.name}
//                   active={pathname === item.route}
//                   component={<Link to={item.route} />}
//                 >
//                   {item.custom_name}
//                 </MenuItem>
//               ))}
//             </SubMenu>
//           );
//         })}
//       </Menu>

//     </Sidebar>
//   );
// }

// export default Sidenav;

import { useEffect, useState } from "react";
import { Menu } from "antd";
import { AppstoreOutlined } from "@ant-design/icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Utilities from "../../dependencies/custom/react-utilities";
import ValuesStore from "../../store/values-store";
import Settings from "../../dependencies/custom/settings";

let myPagesRequest = null;

async function fetchMyPages(navigate, getValue, setValue) {
  const cachedPages = getValue("pages");
  if (Array.isArray(cachedPages) && cachedPages.length) {
    return cachedPages;
  }

  if (!myPagesRequest) {
    myPagesRequest = Utilities.fetchWithAuth(
      "GET",
      Settings.urls.rbac.mypages,
      undefined,
      navigate,
    )
      .then((res) => {
        if (!res?.ok) {
          throw res;
        }

        const pagesData = res?.data?.pages || [];
        const deduplicatedPages = Utilities.removeDuplicateUsingKey(
          pagesData,
          "route",
        );
        setValue("pages", deduplicatedPages);
        return deduplicatedPages;
      })
      .finally(() => {
        myPagesRequest = null;
      });
  }

  return myPagesRequest;
}

const ROOT_PARENT_KEY = "null";

function numericOrder(value, fallback = 0) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

function pageLabel(page) {
  if (page?.route === "/admin/accommodation") return "Houses and Dormitories";
  return page?.custom_name || page?.customName || page?.name || "";
}

function pageSubParent(page) {
  return page?.sub_parent || page?.subParent || null;
}

function pageSubParentOrder(page) {
  return numericOrder(
    page?.sub_parent_order ?? page?.subParentOrder,
    numericOrder(page?.order),
  );
}

function sortMenuItems(a, b) {
  const orderDiff = numericOrder(a?.order) - numericOrder(b?.order);
  if (orderDiff !== 0) return orderDiff;
  return String(a?.labelText || a?.key || "").localeCompare(
    String(b?.labelText || b?.key || ""),
  );
}

function createPageMenuItem(page, { showIcon = true } = {}) {
  const label = pageLabel(page);

  return {
    key: page?.route || page?.name || label,
    icon: showIcon && page?.icon ? <i className={page.icon} /> : null,
    label: page?.route ? <Link to={page.route}>{label}</Link> : label,
    labelText: label,
    order: numericOrder(page?.order),
    display: numericOrder(page?.display),
  };
}

function findOpenKeysForSelectedItem(items, selectedKey, parentKeys = []) {
  for (const item of items || []) {
    if (item?.key === selectedKey) {
      return parentKeys;
    }

    if (item?.children?.length) {
      const childOpenKeys = findOpenKeysForSelectedItem(
        item.children,
        selectedKey,
        [...parentKeys, item.key],
      );

      if (childOpenKeys.length) {
        return childOpenKeys;
      }
    }
  }

  return [];
}

function MyMenu({ myTheme }) {
  const { getValue, setValue } = ValuesStore();
  const { pathname } = useLocation();
  const [pages, setPages] = useState(() => {
    const cachedPages = getValue("pages");
    return Array.isArray(cachedPages) ? cachedPages : [];
  });
  const navigate = useNavigate();

  const [menuItems, setMenuItems] = useState([]);
  const [openKeys, setOpenKeys] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const loadPages = async () => {
      try {
        const fetchedPages = await fetchMyPages(navigate, getValue, setValue);
        if (isMounted) {
          setPages(Array.isArray(fetchedPages) ? fetchedPages : []);
        }
      } catch (res) {
        if (isMounted) {
          Utilities.showNotification(undefined, res?.msg);
          setPages([]);
        }
      }
    };

    loadPages();

    return () => {
      isMounted = false;
    };
  }, [getValue, navigate, setValue]);

  useEffect(() => {
    const visiblePages = (pages || []).filter(
      (page) => numericOrder(page?.display) === 1,
    );

    /** 1. Group pages by parent */
    const grouped = visiblePages.reduce((acc, page) => {
      const parent = page?.parent ?? ROOT_PARENT_KEY;
      acc[parent] = acc[parent] || [];
      acc[parent].push(page);
      return acc;
    }, {});

    let finalMenu = [];

    /** 2. Handle parent = null -> standalone menu items */
    const rootItems = grouped[ROOT_PARENT_KEY] || [];
    rootItems
      .sort((a, b) => numericOrder(a?.order) - numericOrder(b?.order))
      .forEach((item) => {
        finalMenu.push(createPageMenuItem(item));
      });

    if (
      visiblePages.some((page) => page?.route?.startsWith("/student/")) &&
      !visiblePages.some((page) => page?.route === "/student/lms")
    ) {
      finalMenu.push(createPageMenuItem({
        name: "student_lms",
        custom_name: "My Learning",
        route: "/student/lms",
        icon: "fas fa-play-circle",
        order: 2,
        display: 1,
      }));
    }

    /** 3. Handle parents with direct children and optional sub-parent folders */
    Object.entries(grouped)
      .filter(([key]) => key !== ROOT_PARENT_KEY) // exclude root items
      .forEach(([parentName, ch]) => {
        const directChildren = [];
        const subParentGroups = {};

        (ch || []).forEach((page) => {
          const subParent = pageSubParent(page);
          if (subParent) {
            subParentGroups[subParent] = subParentGroups[subParent] || [];
            subParentGroups[subParent].push(page);
          } else {
            directChildren.push(page);
          }
        });

        const children = [
          ...directChildren
            .sort((a, b) => numericOrder(a?.order) - numericOrder(b?.order))
            .map(createPageMenuItem),
          ...Object.entries(subParentGroups).map(
            ([subParentName, subPages]) => {
              const sortedPages = [...subPages].sort(
                (a, b) => numericOrder(a?.order) - numericOrder(b?.order),
              );
              const subParentOrder = Math.min(
                ...sortedPages.map((p) =>
                  parentName === "Academics"
                    ? numericOrder(p?.order)
                    : pageSubParentOrder(p),
                ),
              );

              return {
                key: `${parentName}::${subParentName}`,
                label: subParentName,
                labelText: subParentName,
                order: subParentOrder,
                display: 1,
                children: sortedPages.map((page) =>
                  createPageMenuItem(page, { showIcon: false }),
                ),
              };
            },
          ),
        ].sort(sortMenuItems);

        // pick icon for submenu
        const parentIcon = ch.find((c) => c.parent_icon != null)?.parent_icon;
        if (children.length) {
          finalMenu.push({
            key: parentName,
            icon: parentIcon ? (
              <i className={parentIcon} />
            ) : (
              <i className="fas fa-question-circle" />
            ),
            label: parentName,
            labelText: parentName,
            order: children.length ? children[0]?.order : 0, // parent order = first visible child or sub-parent
            display: 1,

            children,
          });
        }
      });

    /** 4. Sort everything by order */
    finalMenu.sort(sortMenuItems);
    const dashboardItem = {
      key: "/welcome/me",
      icon: <AppstoreOutlined />,
      label: <Link to="/welcome/me">Dashboard</Link>,
      labelText: "Dashboard",
      order: Number.MIN_SAFE_INTEGER,
      display: 1,
    };
    const visibleMenuItems = finalMenu.filter(
      (item) => item?.display === 1 && item?.key !== dashboardItem.key,
    );
    setMenuItems([dashboardItem, ...visibleMenuItems]);
  }, [pages]);

  useEffect(() => {
    const selectedOpenKeys = findOpenKeysForSelectedItem(menuItems, pathname);
    if (!selectedOpenKeys.length) return;

    setOpenKeys((currentOpenKeys) => {
      const mergedOpenKeys = [
        ...new Set([...currentOpenKeys, ...selectedOpenKeys]),
      ];
      if (mergedOpenKeys.length === currentOpenKeys.length) {
        return currentOpenKeys;
      }

      return mergedOpenKeys;
    });
  }, [menuItems, pathname]);

  return (
    <Menu
      theme={myTheme}
      mode="inline"
      selectedKeys={[pathname]}
      openKeys={openKeys}
      onOpenChange={setOpenKeys}
      items={menuItems}
    />
  );
}

export default MyMenu;

// import { useEffect, useState } from "react";
// import { Menu } from "antd";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import Utilities from "../../dependencies/custom/react-utilities";
// import ValuesStore from "../../store/values-store";
// import Settings from "../../dependencies/custom/settings";

// function MyMenu({ myTheme }) {
//   const valuesStore = ValuesStore();
//   const { pathname } = useLocation();
//   const navigate = useNavigate();

//   const [pages, setPages] = useState([]);
//   const [menuItems, setMenuItems] = useState([]);
//   const [openKeys, setOpenKeys] = useState([]);

//   /** Fetch pages once */
//   useEffect(() => {
//     const fetchPages = async () => {
//       const res = await Utilities.fetchWithAuth(
//         "GET",
//         Settings.urls.rbac.mypages,
//         undefined,
//         navigate
//       );

//       if (res?.ok) {
//         const pagesData = res?.data?.pages || [];
//         valuesStore.setValue("pages", pagesData);
//         setPages(pagesData);
//       } else {
//         Utilities.showNotification(undefined, res?.msg);
//         setPages([]);
//       }
//     };

//     fetchPages();
//   }, [navigate]);

//   /** Build menu items whenever pages change */
//   useEffect(() => {
//     const grouped = Utilities.groupBy(pages || [], "parent");
//     let finalMenu = [];

//     // root items (parent = null)
//     const rootItems = grouped["null"] || [];
//     rootItems
//       .sort((a, b) => a.order - b.order)
//       .forEach((item) => {
//         finalMenu.push({
//           key: item.route,
//           icon: item.icon ? <i className={item.icon} /> : null,
//           label: <Link to={item.route}>{item.custom_name}</Link>,
//           order: item.order,
//           display: item.display,
//         });
//       });

//     // parents with children
//     Object.entries(grouped)
//       .filter(([key]) => key !== "null")
//       .forEach(([parentName, ch]) => {
//         const children = ch
//           ?.filter((v) => v?.display === 1)
//           .sort((a, b) => a.order - b.order);

//         const parentIcon = children.find((c) => c.parent_icon != null)?.parent_icon;

//         finalMenu.push({
//           key: parentName,
//           icon: parentIcon ? <i className={parentIcon} /> : null,
//           label: parentName,
//           order: children[0].order,
//           display: 1,
//           children: children.map((child) => ({
//             key: child.route,
//             order: child.order,
//             display: child.display,
//             label: <Link to={child.route}>{child.custom_name}</Link>,
//           })),
//         });
//       });

//     finalMenu.sort((a, b) => a.order - b.order);
//     const filtered = finalMenu.filter((v) => v?.display === 1);
//     setMenuItems(filtered);
//   }, [pages]);

//   /** Control openKeys based on current pathname */
//   useEffect(() => {
//     if (!menuItems.length) return;

//     const parentKey = menuItems.find((item) =>
//       item.children?.some((child) => child.key === pathname)
//     )?.key;

//     if (parentKey) {
//       setOpenKeys([parentKey]);
//     } else {
//       setOpenKeys([]);
//     }
//   }, [menuItems, pathname]);

//   return (
//     <Menu
//       theme={myTheme}
//       mode="inline"
//       selectedKeys={[pathname]}
//       items={menuItems}
//       openKeys={openKeys}
//       onOpenChange={(keys) => setOpenKeys(keys)}
//     />
//   );
// }

// export default MyMenu;
